import { render, staticRenderFns } from "./enrollmentAliasEdit.vue?vue&type=template&id=2dc26b19&scoped=true&lang=html&"
import script from "./enrollmentAliasEdit.vue?vue&type=script&lang=js&"
export * from "./enrollmentAliasEdit.vue?vue&type=script&lang=js&"
import style0 from "./enrollmentAliasEdit.vue?vue&type=style&index=0&id=2dc26b19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc26b19",
  null
  
)

export default component.exports